import {
    FETCH_PRODUCTS,
    FETCH_ONE_PRODUCT,
    FETCH_ERROR,
    FETCH_LOADING,
    FETCH_SEARCH,
} from "../types/types";

const initialState = {
    Product: [],
    ProductOne: {},
    Search: [],
    SearchKey: "",
    Error: "",
    Loading: false,
};

export const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCTS:
            return {
                ...state,
                Product: action.payload,
                Loading: false,
            };
        case FETCH_ONE_PRODUCT:
            return {
                ...state,
                ProductOne: action.payload,
                Loading: false,
            };
        case FETCH_ERROR:
            return {
                ...state,
                Error: action.payload,
            };
        case FETCH_LOADING:
            return {
                ...state,
                Loading: true,
            };
        case FETCH_SEARCH:
            return {
                ...state,
                Loading: false,
                Search: action.payload,
                SearchKey: action.data,
            };
        default:
            return state;
    }
};
